export default {
    fund: [{
            "title": "关于证券投资组合的贝塔系数，以下表述错误的是（　　）。",
            "question": "A．贝塔系数小于1且大于0时，该投资组合的价格变动幅度比市场小\nB．贝塔系数和相关系数一样，只能介于1和-1之间\nC．通过对贝塔系数的计算，投资者可以得出单个证券或证券组合未来将面临的市场风险状况\nD．贝塔系数反映的是投资对象对市场变化的敏感度",
            "answer": "B",
            "explain": "贝塔系数是一种证券或一个投资证券组合相对于大盘的表现情况。贝塔系数衡量股票收益相对于业绩评价基准收益的总体波动性，是一个相对指标。贝塔值越高，意味着股票相对于业绩评价基准的波动性越大。贝塔值大于1，则股票的波动性大于业绩评价基准的波动性，反之亦然。如果是负债，则显示其变化的方向与大盘的变化方向相反；大盘涨的时候它跌，大盘跌的时候它涨。贝塔系数为1，即投资组合的价格与市场一同变动。贝塔系数高于1，即投资组合价格比总体市场更波动。贝塔系数低于1（大于0），即证券价格的波动性比市场低。贝塔系数大于0，说明投资组合的价格变动方向与市场一致，小于零说明方向相反。当β=0时，预期收益不为0，为无风险收益率。β系数不能表示对放弃即期消费的补偿。"
        },
        {
            "title": "关于基金分红与基金分拆，以下表述错误的是（　　）。",
            "question": "A．基金分红会造成大量的现金流出基金资产，而基金分拆却不会\nB．基金分红不需要严格的时机选择，而基金分拆则需要进行时机选择\nC．分红有时需要卖出部分基金资产，基金分拆却不需要\nD．现金分红的投资者在获得分红时，其基金份额并没有变化，但基金分拆的投资者的基金份额却有较大变化",
            "answer": "B",
            "explain": "基金分拆是指在保证投资者的投资总额不发生改变的前提下，将一份基金按照一定的比例分拆成若干份，每一基金份额的单位净值也按相同比例降低。是对基金的资产进行重新计算的一种方式。基金份额分拆通过直接调整基金份额数量达到降低基金份额净值的目的，但并不影响基金的已实现收益、未实现利得等。与基金分红比较相似的是，基金进行分拆也可以降低基金单位净值，事实上基金的分拆类似于基金分红中红利再投资的模式。"
        },
        {
            "title": "“1亿元的组合有1亿元的管法，10亿元的组合有10亿元的管法，100亿元的组合更有100亿元的管法”，这说明基金业绩评价需考虑以下哪个方面（　　）。",
            "question": "A．申购金额\nB．初始募集资金\nC．赎回金额\nD．基金管理规模",
            "answer": "D",
            "explain": "基金业绩评价应考虑基金管理规模、时间区间、风险和收益。不同的规模有不同的管理方法，所以都是考虑了规模。题目中1亿、10亿、100亿是基金的规模大小。"
        },
        {
            "title": "会员制证券交易所的决策机构是（　　）。",
            "question": "A．会员大会\nB．总经理\nC．专门委员会\nD．理事会",
            "answer": "D",
            "explain": "证券交易所的组织形式有会员制和公司制两种，我国上海证券交易所和深圳证券交易所都采用会员制，设会员大会、理事会和专门委员会。理事会是证券交易所的决策机构，理事会下面可以设立其他专门委员会，证券交易所设总经理，负责日常事务。总经理由国务院证券监督管理机构任免。故本题选D。"
        },
        {
            "title": "期货市场风险管理的功能是通过（　　）实现的。",
            "question": "A．交割\nB．建仓\nC．套期保值\nD．买卖",
            "answer": "C",
            "explain": "期货市场风险管理的功能是通过套期保值实现的。"
        },
        {
            "title": "在每一风险水平上能够取得（　　）收益的投资组合的集合，即构成有效市场前沿。",
            "question": "A．最低\nB．最高\nC．预期\nD．平均",
            "answer": "B",
            "explain": "资产收益的相关性。有效前沿是由全部有效投资组合构成的集合。如果一个投资组合在所有风险相同的投资组合中具有最高的预期收益率，或者在所有预期收益率相同的投资组合中具有最小的风险，那么这个投资组合就是有效的。"
        }, {
            "title": "某投资者持有一张附息票据，面额为10,000元，票面利率为5%，出票日期为2019年2月11日，到期日期为2019年5月12日，则到期日的利息和本息分别为（　　）元。（注：一年按360天计算）",
            "question": "A．500; 10500\nB．125; 10125\nC．500; 10125\nD．125; 10500",
            "answer": "B",
            "explain": "2019年2月11日至2019年5月12日，为1/4年，因此到期日利息为10000×5%×1/4=125元，本息为10000+125=10125元。"
        },
        {
            "title": "关于跟踪误差，以下表述错误的是（　　）。",
            "question": "A．跟踪误差是证券组合的真实收益率与基准组合收益率之差\nB．一个投资组合可以总收益波动率很大，但其跟踪误差很小\nC．计算跟踪误差必须选择基准组合\nD．跟踪误差主要衡量一个股票组合相对于基准组合的偏离程度",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "小明于2018年4月6日被聘为某货币市场基金的基金经理，主要负责所管理的货币市场基金的投资管理工作。在接受基金经理任命后，小明管理该只货币市场基金以价格为96.1538元/张，买入某商业银行贴现发行的票面为100元的债券共计100万张，期限为1年。关于货币市场基金，以下表述错误的是（　　）。",
            "question": "A．货币市场基金不能投资于剩余期限一年以上的金融工具\nB．货币市场基金的投资对象是货币市场工具\nC．货币市场基金具有风险低、流动性好的特点\nD．可转债不属于货币市场基金可以投资的金融工具",
            "answer": "A",
            "explain": "货币市场基金具有风险低、流动性好的特点。"
        },
        {
            "title": "能够全面反映基金在一定时期内经营成果的财务指标是（　　）。",
            "question": "A．期末可供分配利润\nB．未分配利润\nC．本期利润\nD．本期已实现收益",
            "answer": "C",
            "explain": "本期利润是基金在一定时期内全部损益的总和，包括计入当期损益的公允价值变动损益。该指标既包括了基金已经实现的损益，也包括了未实现的估值增值或减值，是一个能够全面反映基金在一定时期内经营成果的指标。"
        },
        {
            "title": "下列基金业绩指标中，基于资本资产定价模型提出的业绩指标的是（　　）。",
            "questions": "I．夏普比率<br>II．特雷诺比率<br>III．持有区间收益率<br>IV．信息比率",
            "question": "A．II、III、IV\nB．I、II、IV\nC．I、II、III\nD．I、II",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "终值表示的是货币时间价值的概念。用复利法计算第n期期末终值的计算公式为（　　）。",
            "question": "A．PV=FV*(1+i)^n\nB．FV=PV*(1+i)^n\nC．PV=FV/(1+i)^n\nD．PV=FV*(1+i*n)",
            "answer": "B",
            "explain": "FV=PV*(1+i)^n，其中(1+i)^n为复利终值系数或1元的复利终值，用符号(FV, i, n)表示，i为年利率，PV为现值，FV为终值。"
        },
        {
            "title": "关于基金中基金的估值，以下表述错误的是（　　）。",
            "question": "A．被投资基金前一估值日至估值日期间发生分红除权、折算或者拆分，按所投资基金前一估值日的份额净值或收盘价估值\nB．以所投资基金的收盘价估值的，如估值日无交易，且最近交易日后市场环境未发生重大变化，按最近交易日的收盘价估值\nC．投资标的为境内上市交易型货币市场基金，如该基金披露份额净值，可以按所投资基金估值日的份额净值\nD．以所投资基金的基金份额净值估值的，若所投资基金与该基金中基金的估值频率一致但未公布估值日净值，按其最近公布的份额净值或估值",
            "answer": "A",
            "explain": "如果所投资基金前一估值日至估值日期间发生分红除权、折算或拆分，基金管理人应根据基金份额净值或收盘价、单位基金份额分红金额、折算拆分比例、持仓份额等因素合理确定公允价值。"
        }, {
            "title": "关于混合型基金的风险管理，以下表述错误的是（　　）。",
            "question": "A．偏债型混合基金需要重点对期限结构、杠杆率、流动性等指标进行监控\nB．混合型基金根据投资比例，可以划分为偏股型基金、偏债型基金、平衡型基金等\nC．偏股型混合基金需要重点对组合久期、信用评级等指标进行监控\nD．混合型基金的风险和预期收益低于股票型基金，高于债券型基金",
            "answer": "C",
            "explain": "混合型基金根据投资比例，可以划分为偏股型基金、偏债型基金、平衡型基金等。由于混合基金的股票仓位比股票型基金和债券型基金的更灵活，针对其的风险管理也更多样化，具体可根据基金当时的股票仓位和面临的主要投资风险进行控制。目前混合基金的股票仓位灵活，使得基金在市场下跌时有了规避系统性风险的可能。"
        },
        {
            "title": "投资组合A、B、C、D的贝塔系数分别为-0.5、-0.2、0.8、1.1，若投资者预期股市将步入牛市，为获取更高收益率，则组合（　　）更具有优势。",
            "question": "A．A\nB．D\nC．A\nD．C",
            "answer": "B",
            "explain": "当组合β系数大于1时，该投资组合的价格变动幅度比市场更大。即将步入牛市的情况下，β系数越大越有利。1.1是最大的，所以组合D更具有优势。"
        },
        {
            "title": "每个交易日，公募基金的托管行与中登完成场内一级资金清算交收后再与其托管的所有证券投资基金分别完成资金的清算工作，这种结算方式是（　　）。",
            "question": "A．双边净额结算方式\nB．全额结算方式\nC．多边净额结算方式\nD．货银对付方式",
            "answer": "C",
            "explain": "多边净额结算与双边净额结算的最大区别是，多边净额结算时交易双方的交收对手发生了变化，所有交易结算都必须通过登记结算机构这个共同的对手方完成。目前我国证券交易的结算采用多边净额结算的方式，中国证券登记结算公司承担着共同对手方的角色。"
        },
        {
            "title": "关于久期和凸性，有如下两种说法：I、如果两个债券的修正久期是相等的，那么它们的价格随收益率变动的百分比变化就总是相等的；II、凸性对投资者是有利的，在其他特性相同时，投资者应当选择凸性更高的债券进行投资。以下判断正确的是（　　）。",
            "question": "A．I错误，II错误\nB．I正确，II正确\nC．I正确，II错误\nD．I错误，II正确",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于通过构建投资组合来分散风险的效果，以下表述正确的是（　　）。",
            "question": "A．可以分散非系统性风险\nB．可以分散系统性风险\nC．系统性风险和非系统性风险均能被完全分散\nD．系统性风险和非系统性风险都不可能被分散",
            "answer": "A",
            "explain": "通过投资资产组合，可以降低风险，但不能完全消除风险。把可以通过构建资产组合分散掉的风险称为非系统性风险，不能通过构造资产组合分散掉的风险称为系统性风险。"
        },
        {
            "title": "某企业的经济附加值为1000万，资本收益率为18%，实际投入资本为1亿元，则其加权平均资本成本为（　　）。",
            "question": "A．8%\nB．12%\nC．28%\nD．10%",
            "answer": "A",
            "explain": "经济附加值是基于税后营业净利润和产生这些利润所需资本投入总成本的一种企业绩效财务评价方法。公司每年创造的经济增加值等于税后净营业利润与全部资本成本之间的差额。其中资本成本包括债务资本的成本，也包括股本资本的成本。EVA=(ROIC-WACC)×实际资本投入，即1000万=(18%-加权平均资本成本)×10000万，算得WACC=8%。"
        },
        {
            "title": "某公募基金管理人在某交易日发生估值错误，以下处理措施中不应采取的是（　　）。",
            "question": "A．管理人发现错误超过基金资产净值的0.25%，及时向中国证监会报告\nB．管理人发现过错原因在于估值人员未遵循基金合同约定，且已经给基金份额持有人造成损失，决定承担赔偿责任\nC．管理人在发现估值错误后，判断错误不会产生重大影响，决定忽略该错误\nD．管理人在发现估值错误后，立即启动应急方案纠正错误",
            "answer": "C",
            "explain": ""
        }, {
            "title": "以下指标中，可以反应股票基金风险的是（　　）。",
            "questions": "I．标准差<br>II．贝塔系数<br>III．持股集中度<br>IV．行业投资集中度",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．III、IV\nD．I、IV",
            "answer": "A",
            "explain": "常用来反应股票基金风险的指标有标准差、贝塔系数、持股集中度、行业投资集中度、持股数量等。"
        },
        {
            "title": "根据人民银行的规定，目前我国银行间质押式回购的最长期限是（　　）。",
            "question": "A．三个月\nB．一个月\nC．一年\nD．六个月",
            "answer": "C",
            "explain": "中国人民银行规定，质押式回购期限最长为1年，在1年之内由投资者双方自行商定回购期限。"
        },
        {
            "title": "A、B两只股票的收益率相关系数为0.4，甲的股票账户全仓买入股票A，乙的股票账户全仓买入股票B，乙的账户市值是甲的2倍，则甲乙两人账户市值的收益率相关系数是（　　）。",
            "question": "A．0.56\nB．0.8\nC．0.4\nD．0.2",
            "answer": "C",
            "explain": "相关系数不随着账户市值的变化而变化，故相关系数仍是0.4。"
        },
        {
            "title": "关于利润表，下述说法正确的是（　　）。",
            "question": "A．营业外支出应计入营业成本\nB．营业收入扣除营业成本、销售费用、管理费用即利润总额\nC．利润总额扣除所得税费用即净利润\nD．在计算营业利润时不应扣除财务费用",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "采用被动投资策略的投资者，通常（　　）。",
            "question": "A．认为市场并非完全有效\nB．通过跟踪指数获得基准指数的回报\nC．试图利用技术预测市场总体走势调整股票组合\nD．尝试利用基本面分析找出被低估或高估的股票",
            "answer": "B",
            "explain": "被动投资者一般认为市场是有效的，主动投资者一般认为市场是无效的。被动投资者试图复制某一业绩基准，通常是指数的收益和风险。在此策略下，投资经理不会尝试利用基本面分析找出被低估或被高估的股票，也不会试图利用技术分析或数量分析方法预测市场的总体走势，并根据市场走势相应地调整股票组合。被动投资通过跟踪指数获得基准指数的回报。对于目标就是复制指数的被动投资策略来说，由于跟踪"
        },
        {
            "title": "目前国际上被称为三大农产品期货的是（　　）。",
            "question": "A．大豆、玉米和鸡蛋的期货\nB．大豆、玉米和棉花的期货\nC．大豆、玉米和咖啡的期货\nD．大豆、玉米和小麦的期货",
            "answer": "D",
            "explain": "目前，国际上可交易的农产品类大宗商品主要包括玉米、大豆、小麦、稻谷、咖啡、棉花、鸡蛋、棕榈油、菜油、白砂糖等，其中大豆、玉米、小麦的期货被称为三大农产品期货。"
        },
        {
            "title": "某投资者看好某只股票，计划6个月后增持，但希望将价格锁定到现在的水平。为实现这个投资目标，该投资者比较直接可行的做法是（　　）。",
            "question": "A．做空该股票的期货\nB．卖出该只股票的认购期权\nC．直接投资与该只股票正相关的指数ETF\nD．与证券公司订立该只股票收益互换协议",
            "answer": "D",
            "explain": "投资者和证券公司之间的股票收益互换有三种模式：固定利率和股票收益的互换，股票收益和固定利率的互换，股票收益和股票收益的互换。"
        }, {
            "title": "某公募基金在2019年6月1日在二级市场买入股票A100000股，2019年6月5日获得该股票派发的现金股利5000元，2019年7月3日该基金卖出全部持仓的股票A，该公募基金需要对该现金股利所缴纳（　　）元个人所得税。",
            "question": "A．50\nB．1000\nC．500\nD．0",
            "answer": "B",
            "explain": "对证券投资基金从证券市场中取得的收入，包括买卖股票、债券的差价收入，股权的股息、红利收入，债券的利息收入及其他收入，暂不征收企业所得税。对基金取得的股利收入、债券的利息收入、储蓄存款利息收入，由上市公司、发行债券的企业和银行在向基金支付上述收入时代扣代缴20%的个人所得税。"
        },
        {
            "title": "每经过一个计息期，要将所生利息加入本金再计算利息的是（　　）。",
            "question": "A．单利\nB．浮动利率\nC．复利\nD．固定利率",
            "answer": "C",
            "explain": "要将所生利息加入本金再计算利息的是复利计息方式。"
        },
        {
            "title": "关于收益率曲线，以下表述正确的是（　　）。",
            "question": "A．债券信用等级能够完全解释债券收益率的变动\nB．在不同的市场阶段观察到的收益率曲线形态大致相同\nC．描述债券到期收益率和债券到期期限之间关系的曲线\nD．一般的短期债券倾向于比长期债券提供更高的收益率",
            "answer": "C",
            "explain": "不同市场阶段观察到的收益率曲线不同，收益率曲线有四种基本类型，一般来讲，短期债券倾向于比长期债券更低的收益率。不同债券的收益率差异，一定程度上可以用不同的信用等级来解释，但信用等级并不能完全解释债券收益率的波动。将不同期限债券的收益率和到期期限的关系在以期限为横坐标，收益率为纵坐标的直角坐标系上表示出来，就得到收益率曲线。"
        },
        {
            "title": "某日，投资者小田在场内申购了A跨境ETF5000元，B货币ETF3000元，买入了C私募债券2000元，小田先后在账户中存入5000元1000元。若不考虑交易成本，则交收日的交收结果是（　　）。",
            "question": "A．A和B交易成功，C交易成功2000元\nB．3笔交易全部失败\nC．A和B交易成功，C交易成功1000元\nD．A和B交易成功，C交易成功0元",
            "answer": "D",
            "explain": "跨境ETF申购，货币ETF申购，私募债券场内交易交收采用全额结算，任何一方应付资金或应付证券不足的交收失败。"
        },
        {
            "title": "甲公司2015年经营活动产生的现金流量为200亿元，投资活动产生的现金流量为100亿元，筹资活动产生的现金流量为-50亿元，则甲公司2015年的净现金流（　　）亿元。",
            "question": "A．150\nB．300\nC．50\nD．250",
            "answer": "D",
            "explain": "经营活动产生的现金流量CFO；投资活动产生的现金流量CFI；筹资活动产生的现金流量CFF；三部分现金流加总则得到净现金流量NCF，即NCF=CFO+CFI+CFF；200亿+100亿-50亿=250亿。"
        },
        {
            "title": "以下不属于按保证形式划分的有保证债券的是（　　）。",
            "question": "A．信用债券\nB．抵押债券\nC．质押债券\nD．担保债券",
            "answer": "A",
            "explain": "债券有无保证是影响债券信用等级的重要因素，因此可分为有保证债券和无保证债券，后者也称为信用债券。有保证债券根据保证的形式不同，可分为抵押债券、质押债券和担保债券。抵押债券的保证物是土地、房屋、设备等不动产；质押债券的保证物是债券发行者持有的债权或股权，而非真实资产；担保债券则由另一实体提供保证发行的债券。"
        }, {
            "title": "关于交易指令在基金公司内部的执行，以下表述错误的是（　　）。",
            "question": "A．交易员在执行交易的过程中必须严格按照公平公正的原则执行交易\nB．交易员收到指令后有权根据自身对市场的判断选择合适时机完成交易\nC．在自主权限内，基金经理通过交易系统向交易室下达交易指令\nD．基金经理下达的所有交易指令，都会被分发给交易员",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "某年底资金面持续紧张，货币市场利率快速上行，叠加信用风险事件不断爆出，债券市场大幅调整，货币市场利率大幅上行导致货币基金吸引力下降，机构投资者短期集中大额赎回，个别货币基金面临流动性压力。关于上述事件中基金的投资风险，以下表述错误的是（　　）。",
            "question": "A．机构持有人占比和结构会影响基金的流动性\nB．基金经理要管理信用风险，降低信用风险事件对基金的影响\nC．资金面紧张、货币市场利率上行时基金造成的风险属于市场风险范畴\nD．流动性风险是一种综合性风险，市场、信用等领域风险管理的缺陷必然导致流动性风险",
            "answer": "D",
            "explain": "流动性风险是一种综合性风险。与市场风险、信用风险和操作风险相比，其形成原因更加复杂。市场、信用、操作等各个领域的风险管理的缺陷，都可能导致流动性出现问题，并非必然出现的。"
        },
        {
            "title": "某机构投资者持有投资组合占比相同的F、J和H基金组成。其中，F、J股票基金的平均年化收益率为15%和8%，系统风险β分别为1.2和0.6；H为债券基金，平均年化收益率为4%，久期为3年。请计算该组合的加权平均年化收益率是（　　）。",
            "question": "A．8%\nB．7%\nC．6%\nD．9%",
            "answer": "D",
            "explain": "因投资组合由占比相同的F、J和H基金组成，所以加权平均年化收益率=%15×1/3+8%×1/3+4%×1/3=9%。"
        },
        {
            "title": "关于资本资产定价模型，以下表述错误的是（　　）。",
            "question": "A．所有投资者都可以以无风险利率无限借贷\nB．所有投资者都有相同的投资期限，并不在投资期限内对投资组合做动态调整\nC．所有投资者都是风险喜好者\nD．所有投资者都认为同一股票有相同的风险和收益分布",
            "answer": "C",
            "explain": "资本市场理论和资本资产定价模型的前提假设包括：（1）所有的投资者都是风险厌恶者。（2）投资者可以以无风险利率任意地借入或贷出资金。（3）所有投资者的期望相同。（4）所有投资者的投资期限都是相同的，并且不在投资期限内对投资组合做动态的调整。（5）所有的投资者都可以无限份额，投资数量熟悉。（6）无摩擦市场。（7）投资者是价格的接受者。"
        }, {
            "title": "某基金的业绩比较基准为沪深300指数收益率×85% + 中国债券总指数收益率×15%，则（　　）。",
            "question": "A．该基金属于被动管理股票型基金\nB．该基金属于小盘风格基金\nC．该基金属于债券型基金\nD．该基金属于主动管理股票型基金",
            "answer": "A",
            "explain": "80%以上的基金资产投资于股票的，为股票基金。被动投资通过跟踪指数获得基准指数的回报。所以该基金为被动管理股票型基金。"
        },
        {
            "title": "关于财务报表，以下表述正确的是（　　）。",
            "questions": "I．资产负债表记载的信息为时点数，通常为会计季末、半年末或年末<br>II．分析资产负债表可以了解企业资产要素、偿债能力、资本结构、股东权益结构等信息<br>III．资产负债表的基本逻辑关系一股情況下都成立，但在所有者权益为负时除外<br>IV．资产负债表与利润表及现金流量表从不同角度记录反映企业的经营情况，相互之间关系不大",
            "question": "A．I、II\nB．II、III、IV\nC．I、III\nD．I、II、III",
            "answer": "A",
            "explain": "I说法正确，资产负债表记录的信息为时点数据，通常为会计季末、半年末或年末；II说法正确，分析资产负债表可以了解企业资产要素、偿债能力、资本结构、股东权益结构等信息；III说法错误，资产负债表反映的是企业在某一特定日期的财务状况，利润表反映企业在一定会计期间经营成果，现金流量表反映在特定会计期间内企业的现金流入和流出情况，它们之间存在重要关联，并非关系不大；IV说法错误，资产负债表、利润表及现金流量表从不同角度记录反映企业的经营情况，相互关联，关系重大 。"
        },
        {
            "title": "下列投资者买卖基金活动产生的各项，需要征收增值税的是（　　）。",
            "question": "A．某机构投资者购入基金并持有至到期\nB．某保险公司买入某基金，一年后卖出\nC．小王买入某开放式基金，半年后卖出\nD．某香港市场投资者通过基金互认买卖内地基金份额",
            "answer": "B",
            "explain": "根据《营业税改征增值税试点有关事项的规定》，机构投资者买卖基金份额属于金融商品转让，应按卖出价扣除买入价后的余额为销售额计征增值税。机构投资者购入基金、信托、理财产品等各类资产管理产品持有至到期，不属于金融商品转让。根据《营业税改征增值税跨境应税行为增值税免税管理办法（试行）》，合格境外投资者（QFII）委托境内公司在我国从事证券买卖业务、香港市场投资者通过基金互认买卖内地基金份额取得的收入免征增值税。"
        }, {
            "title": "关于公募基金的估值程序，以下说法正确的是（　　）。",
            "question": "A．基金份额净值应于每个开放日闭市后，按照基金资产总值除以当日基金份额的余额数量计算\nB．月末、年中和年末已经进行了估值复核的，可不用就基金会计账目进行核对\nC．基金托管人对基金资产估值后，将基金份额净值结果发送给基金管理人进行复核\nD．基金净值由管理人对外公布，由注册登记机构根据确认的基金份额净值计算申购、赎回数额",
            "answer": "D",
            "explain": "估值程序：(1)基金份额净值是按照每个开放日闭市后，基金资产净值除以当日基金份额的余额数量计算；(2)基金日常估值由基金管理人进行。基金管理人每个交易日对基金资产估值后，将基金份额净值结果发给基金托管人；(3)基金托管人按基金合同规定的估值方法。"
        },
        {
            "title": "同业分组业绩比较方法是指，将某基金所在的可比同业中所有的基金按照业绩从高到低进行排序，依序平均分为四个组。以五年期为例，如果某基金在五年期业绩同业组排名中在第一组的，称之为过去五年业绩相对优秀的基金。这里的同业基金分组的数学涵义是（　　）。",
            "question": "A．中位数的概念\nB．分位数的概念\nC．平均值的概念\nD．累计值的概念",
            "answer": "B",
            "explain": "分位数通常被用来研究随机变量X以特定概率（或者一组数据以特定比例）取得大于等于（或小于等于）某个值的情况。本题中将所有数据从大到小排序，分成4组，第一组就是上25%，5年全部位于第一组，就是位于上25%内，这是分位数的应用。"
        },
        {
            "title": "关于基金会计主体，以下表述错误的是（　　）。",
            "question": "A．证券投资基金的管理主体即基金管理公司的经营活动是证券投资基金的会计核算的主要内容之一\nB．基金会计的责任主体是对基金进行会计核算的基金管理人和基金托管人\nC．基金管理公司管理的不同基金之间的投资管理活动要区别开来\nD．作为基金会计主体，基金管理人承担主会计责任，基金托管人对基金管理人的会计核算进行复核并出具复核意见",
            "answer": "A",
            "explain": "基金会计的责任主体是对基金进行会计核算的基金管理人和基金托管人，其中基金管理人承担会计责任，基金托管人对基金管理人的会计核算进行复核并出具复核意见。基金管理公司管理的不同基金之间的投资管理活动要区别开来。基金的会计核算内容包括资产类、负债类、所有者权益类和损益类的核算，涉及基金的投资交易、基金的申购赎回、基金持有证券的上市公司行为、基金资产估值、基金费用计提和支付等。"
        },
        {
            "title": "考察行业中各个股票对基金投资组合收益率的贡献，该分析是属于（　　）。",
            "question": "A．相对收益归因\nB．绝对收益归因\nC．相对收益率\nD．绝对收益率",
            "answer": "B",
            "explain": "在绝对收益归因中，我们考察在特定区间内，每个证券和每个如何行业贡献到组合的整体收益。"
        },
        {
            "title": "某上市公司上年末流通在外的普通股股数为1000万股，上年3月增发新股500万股，本年6月回购本公司股票100万股，上年净利润为400万元，上年末股价为20元，则该股票上年末市盈率为（　　）。",
            "question": "A．45\nB．75\nC．70\nD．50",
            "answer": "D",
            "explain": "上年末的每股收益=净利润/总股份=400万/1000万=0.4元，上年末市盈率=上年末每股价格/上年末的每股收益=20元/0.4元=50，市盈率=每股股价/每股收益，每股收益越高，越具有投资价值，而每股收益越高，对应的市盈率就越低。所以市盈率越小越具有投资价值。"
        },
        {
            "title": "关于风险价值及预期损失的异同，以下表述错误的是（　　）。",
            "question": "A．预期损失是指在给定时间区间和置信区间内，投资组合损失的期望值\nB．风险价值与预期损失都无法体现将来可能发生但没有在历史数据中体现的情景\nC．风险价值是指在给定的时间区间和置信水平下，利率、汇率等市场风险要素发生变化时，投资组合面临的潜在最大损失\nD．风险价值可以体现将来可能发生但没有在历史数据中体现的情景，预期损失则不能体现",
            "answer": "B",
            "explain": "风险价值可以体现将来可能发生但没有在历史数据中体现的情景，预期损失则不能体现，蒙特卡洛模拟每次都可以得到组合在期末可能出现的值，在实行足够数量的模拟后，组合价值的模拟分布将会收敛于组合的真实分布，继而求出最后的组合VaR值。"
        }, {
            "title": "关于冲击成本，以下表述正确的是（　　）。",
            "question": "A．信息泄露不会导致冲击成本\nB．冲击成本可以事先确定\nC．冲击成本可以事后精确计量\nD．冲击成本可以看作是购买流动性的成本",
            "answer": "D",
            "explain": "除了流动性需求，信息泄露也是导致冲击成本的因素。作为一种事后计算指标，冲击成本难以精确计量。"
        },
        {
            "title": "关于另类投资，以下表述正确的是（　　）。",
            "question": "A．艺术品和收藏品的投资价值建立在艺术家声望和销售纪录的条件之上，属于另类投资\nB．另类投资意味着创新投资，所以房地产、大宗商品投资这类有悠久历史的投资不属于另类投资\nC．公募REITS不属于另类投资范围\nD．期货、期权为衍生工具，属于典型的另类投资的范畴",
            "answer": "A",
            "explain": "另类投资通常被认为是传统投资之外的所有投资，股票、债券、期货、期权等均属于传统投资，艺术品和收藏品的投资价值建立在艺术家声望和销售纪录的条件之上，属于另类投资。房地产、大宗商品投资这类有悠久历史的投资也属于另类投资，所以另类投资并不意味着创新投资。"
        },
        {
            "title": "下列哪一类私募股权投资的战略通常是向初创型企业提供资金（　　）。",
            "question": "A．成长权益\nB．危机投资\nC．风险投资\nD．并购投资",
            "answer": "C",
            "explain": "私募股权投资包含多种形式，最为广泛使用的战略包括风险投资、成长权益、并购投资、危机投资和投资私募股权二级市场等。风险投资一般采用股权形式将资金投入提供具有创新性的专门产品或服务的初创型公司。风险投资被认为是私募股权投资中处于高风险领域的战略。风险投资的收益不是来自企业本身的分红，而是来自企业成熟壮大之后的股权转让。"
        },
        {
            "title": "“不要把鸡蛋放在同一个篮子里”这一投资格言说明的风险管理策略是（　　）。",
            "question": "A．风险规避\nB．风险补偿\nC．风险对冲\nD．风险分散",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于同业拆借，以下说法中错误的是（　　）。",
            "question": "A．在我国超额准备金、同业存款、政府活期存款、证券账户保证金存款目前都可作为拆借对象\nB．属于银行间市场，交易主体为商业银行、保险公司、证券公司、基金公司等大型机构\nC．对短期流动性最为敏感，同业拆借利率是衡量市场流动性的基准利率，为其他利率确定提供参考\nD．交易过程通过中央银行电子资金转账系统实现，交易双方可以通过交易商或直接联系",
            "answer": "A",
            "explain": "同业拆借是指金融机构之间以货币借贷方式进行短期资金融通的行为。同业拆借的期限一般较短，最短的是隔夜拆借，最长的接近一年。同业拆借市场属于银行间市场，交易主体为商业银行、保险公司、证券公司、基金公司等大型金融机构。同业拆借市场是对短期流动性最为敏感。"
        },
        {
            "title": "某基金公司设立了一只债券型基金，主要投资于国债、政策性金融债、央行票据、地方政府债、企业债、公司债等，2017年1月该基金投资票面利率为6%，每年付息一次的某3年期债券A，到期收益率为7%，麦考利久期为2.83年。债券A的修正久期为（　　）。",
            "question": "A．2.64年\nB．2.54年\nC．2.83年\nD．3.03年",
            "answer": "A",
            "explain": "修正久期=麦考利久期/(1+y)，其中y是每个付息周期应计收益率，即到期收益率7%，求得修正久期2.83/(1+7%)=2.64年。"
        },
        {
            "title": "关于货币市场基金风险指标，以下表述正确的是（　　）。",
            "question": "A．我国法规要求货币市场基金投资组合平均剩余期限在每个交易日均不得超过397天\nB．投资组合平均剩余期限和平均存续期越短，则货币市场基金的流动性越好，利率风险越低\nC．一般情况下，货币市场基金的杠杆比例越高，收益越低，风险越大\nD．除非发生巨额赎回，货币市场基金债券正回购的资金余额不得超过25%",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "某单位有一张带息期票，面额为20000元，票面利率为8%，出票日期为9月24日，12月23日到期，则到期日收到的利息为（　　）元。",
            "question": "A．160\nB．400\nC．800\nD．40",
            "answer": "B",
            "explain": "债券到期日的利息=面值*票面利率*对应的期数=20000*8%*3/12=400。"
        }, {
            "title": "关于机构投资者，以下表述正确的是（　　）。",
            "question": "A．QFII在中国境内的投资范围没有明确限制\nB．私募基金公司的投资产品的客户数不少于200人\nC．企业年金基金财产可以投资具备良好流动性的股票资产，且配置比例根据市场波动调整，没有明确的限制\nD．私募基金公司是一类特殊的机构投资者，由于受法律约束比公募基金少，其投资渠道投资策略更为多样化",
            "answer": "D",
            "explain": "私募基金公司是一类特殊的机构投资者。私募基金公司的投资产品面向不超过200人的合格投资者发行。由于私募基金所受的法律约束比公募基金少，其投资渠道、投资策略都会更为多样化。企业年金基金财产的投资范围，限于银行存款、国债和其他具有良好流动性的金融产品，包括知期债券回购、信用等级在投资级以上的金融债和企业债、可转换债、投资性保险产品、证券投资基金、股票等。企业年金基金财产在投资过程中需要严格遵循有关法律规定的投资比例限制。QFII在中国境内的投资范围也有明确限制。"
        },
        {
            "title": "下列选项中不可以进行回转交易的是（　　）。",
            "question": "A．债券竞价交易\nB．单市场股票型ETF\nC．权证交易\nD．B股次交易日起",
            "answer": "B",
            "explain": "证券的回转交易是指投资者买入的证券，经确认成交后，在交收完成前全部或部分卖出。根据我国现行的有关交易制度规定，债券竞价交易和股权交易实行当日回转交易，即投资者可以在交易日的任何营业时间内反向卖出已买入但是未完成交收的债券和权证。B股实行次交易日起回转交易。深圳证券交易所对专项资金管理计划收益份额协议交易也实行当日回转交易。"
        },
        {
            "title": "某市场价格为980元的普通债券，其修正久期为8.5，假设该债券的收益率降低了150个基点(1基点等于0.01%)，那么，该债券的实际价格最可能会变动到（　　）。",
            "question": "A．介于855.05元到1104.95元之间\nB．1104.95元\nC．855.05元\nD．大于1104.95元",
            "answer": "D",
            "explain": "本题考查修正久期的计算。 dP/P=-D*moddy,dP表示债券价格变动值，dy表示利率变动的百分比，由此得到， dP=-8.5*980*(-1.5%)=124.95元，124.95+980=1104.95元，此题要考虑凸性的影响，所以实际价格应该大于1104.95元。故本题选D。"
        },
        {
            "title": "关于股票价格，以下表述正确的有（　　）。",
            "questions": "I．股票的理论价格是对未来收益的评定<br>II．股票的理论价格与一定的利率水平有关<br>III．股票的价格由股票的账面价值决定<br>IV．发行价格高于票面价值称为折价发行",
            "question": "A．I、IV\nB．II、III\nC．III、IV\nD．I、II",
            "answer": "D",
            "explain": "股票的理论价格：根据现值理论而来的。将股票的未来收益按市场利率折算成当前价值，即为股票的现值。可见，股票及其他有价证券的理论价格就是以一定利率计算出来的未来收入的现值，I、II项说法正确。"
        },
        {
            "title": "（　　）对有效市场假设理论的阐述最为系统。",
            "question": "A．罗尔\nB．法玛\nC．马可维茨\nD．特雷诺",
            "answer": "B",
            "explain": "20世纪70年代，美国芝加哥大学的教授尤金，法玛决定为市场有效性建立一套标准。法玛依据时间维度，信息以及内部信息。在此基础上，法玛界定了三种形式的有效市场：弱有效，半强有效与强有效。"
        },
        {
            "title": "证券投资基金场内证券交易结算方式不包括（　　）。",
            "question": "A．全额结算\nB．净额结算\nC．分级结算\nD．差额清算",
            "answer": "C",
            "explain": "证券投资基金场内证券交易结算方式包括净额结算（又称差额清算）以及全额结算。故本题选C。"
        }, {
            "title": "在基金资产总值和基金总份额不变的情况下，基金份额净值与基金负债的关系是（　　）。",
            "question": "A．没有关系\nB．可能正相关,也可能负相关\nC．正相关关系\nD．负相关关系",
            "answer": "D",
            "explain": "基金份额净值=基金资产净值/基金总份额，得出基金份额净值越小说明基金资产净值越小，那么，基金资产净值小说明基金负债大。反之，基金负债则小；所以基金份额净值与基金负债呈负相关关系。"
        },
        {
            "title": "一个并非完全有效的市场上，（　　）策略更能体现其价值。",
            "question": "A．ETF投资\nB．主动投资\nC．指数投资\nD．被动投资",
            "answer": "B",
            "explain": "与被动投资相比，在一个并非完全有效的市场上，主动投资策略更能体现其价值，从而给投资者带来较高的回报。这种收益主要来自于如下两种情况：①主动型投资者比其他大多数投资者拥有更好的信息，即市场“共识”以外的有价值的信息；②主动型投资者在面对相同的信息下，能够更高效地使用信息并通过积极的交易产生回报。"
        },
        {
            "title": "某基金行业研究员分析了A服装品牌股票，认为A企业相比前两年，旗下零售门店效率显著提升，数量稳步增加，并逐步向二三线城市渗入，预期今后三年的零售额也将持续较高速增长，管理层相对稳定。这位研究员采用的分析方法是（　　）。",
            "question": "A．相对强度分析\nB．公司基本面分析\nC．技术分析\nD．行业生命周期分析",
            "answer": "B",
            "explain": "要确定股票的合理价值，投资者必须对公司未来的经营业绩和盈利水平进行预测。把诸如分析预期收益等价值决定因素的分析方法称为基本面分析，而公司未来的经营业绩和盈利水平正是基本面分析的核心所在。"
        },
        {
            "title": "以下属于可以从基金资产中列支的交易费用的是（　　）。",
            "question": "A．基金公司股东交易股权的费用\nB．基金份额持有人买卖基金的费用\nC．基金份额持有人基金转换费（基金的上市年费）\nD．基金买卖股票的证管费",
            "answer": "D",
            "explain": "基金销售过程中涉及两类费用：1.基金投资者承担的费用，主要包括申购费、赎回费及基金转换费，不参与基金的会计核算。2.基金管理过程中发生的费用，由基金资产承担，需要从基金财产中列支：（1）基金管理人的管理费；（2）基金托管人的托管费；（3）销售服务费；"
        },
        {
            "title": "以下行为中，能够直接影响基金单位净值的是（　　）。",
            "question": "A．基金申购\nB．基金赎回\nC．基金分红\nD．基金转换",
            "answer": "C",
            "explain": "基金单位资产净值不受基金份额申购赎回的影响。利用基金单位资产净值计算收益率，只需要考虑基金分红，基金分红会导致基金单位净值下降。"
        },
        {
            "title": "下列关于衍生工具风险的论述中，错误的是（　　）。",
            "question": "A．衍生工具中交易双方某方违约的风险属于流动性风险\nB．期货保证金为合约金额的5%，则可以控制20倍于所投资金额的合约资产\nC．因为交易对手无法按时付款或者按时交割会带来结算风险\nD．我国沪深300指数价格走势会影响股指期货沪深300指数合约的价格走势",
            "answer": "A",
            "explain": "衍生工具中交易双方某方违约的风险属于信用风险。衍生工具具有杠杆性，只要支付少量保证金或权利金就可以买入。例如，如果期货交易保证金为合约金额的5%，则可以控制20倍于所投资的合约资产。"
        },
        {
            "title": "证券投资基金进行场内证券交易，除需向券商支付佣金外，还需要支付的交易成本包含（　　）。",
            "question": "A．过户费、经手费、印花税\nB．过户费、托管费、证管费\nC．过户费、销售费、证管费\nD．印花税、交易单元流量费、证管费",
            "answer": "A",
            "explain": "基金通过与券商签订交易单元租用合同，获得投资交易的路径。基金需要向券商支付交易佣金，还需要支付过户费、经手费、证管费、印花税等交易成本。"
        }, {
            "title": "关于投资者承担风险的容忍度，以下表述正确的有（　　）。",
            "questions": "I．投资者的风险容忍度取决于其承担风险的能力和受教育程度两方面<br>II．相比投资期限较短的投资者，投资期限较长的投资者具有更高的风险承受能力<br>III．通常认为承担风险的意愿对机构投资者更为重要<br>IV．保险公司等金融机构在承担风险时往往受到监管约束，对投资风险承担加以限制",
            "question": "A．I、II\nB．I、IV\nC．II、III\nD．II、IV",
            "answer": "D",
            "explain": "投资者的风险容忍度取决于其承担风险的能力和意愿两个方面，I说法错误。具备高于平均水平的风险承受能力和风险承担意愿意味着具备高于平均水平的风险容忍度；反之，则意味着具备低于平均水平的风险容忍度。投资期限较长的投资者具有更高的风险承受能力，其说"
        },
        {
            "title": "上交所规定，符合条件的证券公司可以为在该所上市的ETF产品提供持续的双边报价服务，关于这些证券公司的角色和功能，以下选项正确的是（　　）。",
            "question": "A．充当做市商角色，为市场提供流动性\nB．充当做市商角色，执行投资者的指令\nC．充当经纪人角色，为市场提供流动性\nD．充当经纪人角色，执行投资者的指令",
            "answer": "A",
            "explain": "上交所规定，符合条件的证券公司可以为在该所上市的ETF产品提供持续的双边报价服务，充当做市商角色，为市场提供流动性。"
        },
        {
            "title": "当发生通货紧缩时，实际利率将（　　）名义利率。",
            "question": "A．无法确定\nB．低于\nC．等于\nD．高于",
            "answer": "D",
            "explain": "名义利率=实际利率+通货膨胀率，当通货紧缩时，通货膨胀率为负，实际利率高于名义利率。"
        },
        {
            "title": "关于债券当期收益率，以下表述错误的是（　　）。",
            "question": "A．未考虑折价购买债券并持有到期的情况下，投资者实现的资本利得\nB．未考虑溢价购买债券并持有到期的情况下，投资者可能遭受的资本损失\nC．考虑了货币的时间价值\nD．描述了债券某一期间所获得的现金收入相较于债券价格的比率",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "投资海外美元债券的QDII基金，当人民币对美元大幅升值时，对投资者收益的影响是（　　）。",
            "question": "A．没有影响\nB．正向的\nC．不确定\nD．反向的",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "风险调整后收益指标的局限性包括（　　）。",
            "questions": "I.理论上的无风险收益率与实际应用中的国债收益率可能不同<br>II.证券波动性会加大统计误差，从而影响对超额收益α的测度<br>III.β系数是固定不变的<br>IV.缺少完全具有代表性的市场指数",
            "question": "A．I、II、III、IV\nB．I、II、IV\nC．I、II、III\nD．II、III、IV",
            "answer": "B",
            "explain": "风险调整后收益指标的局限性包括：(1)理论上的无风险收益率（证券市场线中使用的无风险收益率）与实际应用中的国债收益率往往不同；(2)没有被普遍接受或使用的完全具有代表性的市场指数；(3)证券的波动性会使统计误差变得很大，并对超额收益α的测度造成实"
        },
        {
            "title": "2014年上市公司W销售收入为10亿元，总资产收益率5%，净资产收益率10%，销售利润率20%，则W公司2014年的总资产为（　　）。",
            "question": "A．20亿元\nB．40亿元\nC．10亿元\nD．5亿元",
            "answer": "B",
            "explain": "净利润=销售利润率×销售收入=0.2×10亿=2亿，题干给出了总资产收益率实际就是资产收益率=净利润/总资产，那么总资产=净利润/资产收益率=2亿/5%=40亿元。"
        }, {
            "title": "关于资产收益率，以下表述错误的是（　　）。",
            "question": "A．资产收益率计算的是每单位资产所能带来的利润\nB．企业的资产收益率越高，说明企业有较强的利用资产创造利润的能力\nC．计算资产收益率的过程中所使用的净利润是股东可以获得的利润\nD．资产收益率是销售收入总额与总资产总额之比",
            "answer": "D",
            "explain": "资产收益率计算的是每单位资产能带来的利润。公式：资产收益率=净利润总额/总资产总额。"
        },
        {
            "title": "关于可转债，以下表述错误的是（　　）。",
            "question": "A．持有者在转股期内有权将可转债转换成普通股股票\nB．可转债有规定的利率和期限，具备普通债券的特征\nC．转股后，可转债投资者成为公司股东，体现债权债务关系\nD．可转债投资者可以自行选择是否转股",
            "answer": "C",
            "explain": "转股后，可转债投资者成为公司股东，不再体现债权债务关系。"
        },
        {
            "title": "沪港通的开展，在内地与香港之间搭建起资本流通的桥梁。沪港通的双向交易所采用的结算货币是（　　）。",
            "question": "A．美元\nB．人民币或港币\nC．人民币\nD．港币",
            "answer": "C",
            "explain": "沪港通和深港通的双向交易均以人民币结算，有利于推动人民币国际化。"
        },
        {
            "title": "张家村有一百户人家，其中首富老张的家产超过亿元。某调查小组在调查了老张家之后就得出结论，张家村户户都是百万富翁。这里，估算张家村每户人家的家产时，取的是（　　）。",
            "question": "A．分位数\nB．最大值\nC．平均值\nD．中位数",
            "answer": "C",
            "explain": "张家村户户都是百万富翁的结论使用数据应该是平均值；因为首富资产过亿，平均后每户为几百万。"
        },
        {
            "title": "有关债券当期收益率与到期收益率之间的关系，以下表述正确的是（　　）。",
            "question": "A．当期收益率的变动将预示着到期收益率的同方向变动\nB．当期收益率等于债券每年应付的息票利息除以到期收益率\nC．给定其它条件不变，当期收益率和到期收益率的偏离程度与债券市场价格和债券面值的偏离程度呈负相关关系\nD．给定其它条件不变，债券期限越短，当期收益率就越接近到期收益率",
            "answer": "A",
            "explain": "债券当期收益率与到期收益率两者之间的关系如下：(1)债券市场价格越接近债券面值，期限越长，则其当期收益率越接近到期收益率。"
        },
        {
            "title": "关于投资组合管理的基本流程，以下选项中表述正确的是（　　）。",
            "question": "A．主要包括规划、执行和实践三个基本步骤\nB．主要包括规划、研究和执行三个基本步骤\nC．主要包括规划、执行和反馈三个基本步骤\nD．主要包括研究、执行和反馈三个基本步骤",
            "answer": "C",
            "explain": "具体而言，投资组合管理通常包括以下三个基本步骤：(一)规划，确定并量化投资者的投资目标和投资限制；制定投资政策说明书；形成资本市场预期；建立战略资产配置。(二)执行。(三)反馈，监控和再平衡；业绩评估。"
        },
        {
            "title": "以下关于另类投资基金的说法，正确的是（　　）。",
            "question": "A．国内商品QDII只能投资于黄金和石油\nB．国内黄金ETF主要投资于上海黄金交易所的黄金产品，间接投资于实物黄金\nC．国内QDII、REITs产品都是投资于海外的REITs\nD．国内黄金QDII可以直接投资于海外的黄金期货或黄金现货",
            "answer": "B",
            "explain": "经过近年的发展，目前已经形成了四类公募另类投资基金的门类，分别为黄金ETF及黄金ETF联结基金、黄金QDII、REITs产品和商品QDII。"
        },
        {
            "title": "以下选项中，不能用于衡量货币基金风险的指标是（　　）。",
            "question": "A．跟踪误差\nB．平均剩余存续期\nC．融资回购比例\nD．平均剩余期限",
            "answer": "A",
            "explain": "衡量货币市场基金的风险指标主要有投资组合平均剩余期限和平均剩余存续期，融资回购比例、浮动利率债券投资情况以及投资对象的信用评级等。"
        }, {
            "title": "一般来说，以下项目中不体现基金财务会计报告的是（　　）。",
            "question": "A．基金分红能力\nB．基金盈利能力\nC．基金费用情况\nD．基金持有人明细",
            "answer": "D",
            "explain": "一般来说，对股票型基金及混合型基金的财务会计报告的分析包括基金持仓结构分析、基金盈利能力和分红能力分析、基金收入情况分析、基金费用情况分析、基金份额变动分析。"
        },
        {
            "title": "某公司的总资本100万元，其中债权资本和权益资本分别为50万元，公司股东A持有20万元的债权资本和30万元的权益资本，则股东A的认缴权比例通常为（　　）。",
            "question": "A．60%\nB．30%\nC．100%\nD．50%",
            "answer": "A",
            "explain": "权益资本是通过发行股票或置换所有权筹集的资本，在正常经营情况下不会偿还给投资人。两种最主要的权益证券是普通股和优先股，普通股股东有表决权、按持股比例投票权、分配盈余及剩余财产的权利，但分配多少股利取决于公司的经营成果、再投资需求和管理者对支付股利的看法。"
        },
        {
            "title": "关于影响期权价格的因素，以下表述错误的是（　　）。",
            "question": "A．标的资产的波动率越大，期权价值越低\nB．无风险利率升高时，看涨期权的价格随之升高\nC．期权合约的有效期越长，期权价格越高\nD．无风险利率降低时，看跌期权的价格随之升高",
            "answer": "A",
            "explain": "影响期权价格的因素有合约标的资产的市场价格、期权的执行价格、期权的有效期、无风险利率水平、标的资产价格的波动率以及标的资产的分红。标的资产的波动率越大，期权价格越大。"
        },
        {
            "title": "某日，A银行在银行间债券市场做了一笔质押式正回购，融入资金1000万元，回购利率5%，实际占款天数73天，在到期结算日，A银行应向逆回购方支付的资金额为（　　）万元。",
            "question": "A．1100\nB．1001\nC．1010\nD．1000.1",
            "answer": "C",
            "explain": "到期资金估算额=首期资金结算额×(1+回购利率×实际占用天数/365)=1000万×(1+5%×73/365)=1010万。"
        },
        {
            "title": "投资交易中的操作风险是由于人员、流程、系统或外部因素造成的（　　）。",
            "question": "A．交易失误\nB．交易量大额波动\nC．交易未实现\nD．交易价格大幅波动",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于基金公司研究部的职能，以下表述错误的是（　　）。",
            "question": "A．研究部通过系统全面的深入分析选出最具投资潜力的公司，以此为基础选出最优股票\nB．研究部通过宏观、行业及上市公司等进行详细分析和研究，提出投资建议\nC．研究部是基金投资的基础部门\nD．研究部是基金公司管理基金投资的最高决策机构",
            "answer": "D",
            "explain": "投资决策委员会是基金管理公司管理基金投资的最高决策机构。"
        },
        {
            "title": "关于GIPS输入数据的相关规定，以下表述错误的是（　　）。",
            "question": "A．对固定收益类等应计利息的证券，必须采用收付实现制\nB．目前投资管理机构必须采用交易日会计制\nC．目前组合必须以公允价值进行实际估值\nD．目前组合至少每月度进行一次实际估值",
            "answer": "A",
            "explain": "GIPS输入数据的相关规定："
        }, {
            "title": "某基金公司设立了一只债券型基金，主要投资于国债、政策性金融债、央行票据、地方政府债、企业债、公司债等，2017年1月该基金投资了票面利率为6%，每年付息一次的某3年期债券A，到期收益率为7%，麦考利久期为2.83年。根据中国证监会的规定，该基金中债券等固定收益类资产的投资比例不低于基金资产的（　　）。",
            "question": "A．50%\nB．60%\nC．80%\nD．95%",
            "answer": "C",
            "explain": "债券型基金投资债券的比例不低于总资产的80%。股票型基金投资股票的比例不低于总资产的80%。货币型基金须是总资产的100%都要投资货币市场工具。"
        },
        {
            "title": "某投资组合在置信水平为90%，持有期为两周的情况下，如所计算的风险价值为-2.5%，则表明该资产组合的预期损失为（　　）。",
            "question": "A．-2.5%左侧区域损失的期望值\nB．-2%右侧区域损失的期望值\nC．-10%左侧区域发生损失的期望值\nD．10%右侧区域发生损失的平均值",
            "answer": "A",
            "explain": "预期损失，是指在给定时间区间和置信区间内，投资组合损失的期望值。预期损失也被称为条件风险价值，或条件尾部期望或尾部损失。"
        },
        {
            "title": "以下做法属于战术资产配置的是（　　）。",
            "question": "A．某私募基金经理根据其基金投资者的风险承受能力，对基金资产做出事前的、整体性的、最能满足其基金投资者需求的规划和安排\nB．某基金经理根据市场的短期波动，通过择时调节其资产组合各类别资产之间的分配比例\nC．某基金经理通过对组合中债券和股票类资产的长期预期收益率、长期风险水平和资产间的相关性进行比较，运用均值方差模型优化构建最优组合\nD．某私募基金经理为了追求自己管理的基金的长期回报，基于长期投资目标制定了该基金第一个五年资产配置计划",
            "answer": "B",
            "explain": "战术资产配置就是在遵守战略资产配置确定的大类资产比例基础上，根据短期内各特定资产类别的表现，对投资组合中各特定资产类别的权重配置进行调整。战术资产配置对战略资产配置的偏离往往被限制在一定范围内。战术资产配置的周期较短，一般在一年以内，如月度、季度。"
        },
        {
            "title": "投资组合理论的基本假设是（　　）。",
            "question": "A．投资者是风险厌恶的\nB．投资者是理性的\nC．投资者获得的信息都是公开的\nD．投资者是追求高收益的",
            "answer": "A",
            "explain": "马科维茨投资组合理论的基本假设是投资者是厌恶风险的。如果在两个具有相同预期收益率的证券之间进行选择，投资者会选择风险较小的。"
        },
        {
            "title": "政策性金融债的发行人通常不包括（　　）。",
            "question": "A．中国农业银行\nB．中国进出口银行\nC．国家开发银行\nD．中国农业发展银行",
            "answer": "A",
            "explain": "政策性金融债的发行人是政策性金融机构，即国家开发银行、中国农业发展银行、中国进出口银行。"
        },
        {
            "title": "下列主体中，既是银行间债券市场主管部门，又是银行间债券市场发行主体的是（　　）。",
            "question": "A．商业银行\nB．中国证券监督管理委员会\nC．财政部\nD．中国人民银行",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于房地产权益基金，以下表述错误的是（　　）。",
            "question": "A．房地产权益基金可能会以股份公司、有限合伙企业或契约型基金的形式存在\nB．房地产权益基金往往将资产集中配置到一个优质的大型不动产项目中\nC．将所持有的项目打包上市是房地产权益基金退出方式之一\nD．房地产权益基金通常以开放式基金发行",
            "answer": "D",
            "explain": ""
        }, {
            "title": "关于计价错误的处理及责任承担，以下表述错误的是（　　）。",
            "question": "A．基金管理公司在基金估值过程中未能遵循相关法律法规规定或基金合同约定给基金财产造成损失的，对其行为依法承担赔偿\nB．基金托管人在基金估值复核过程中未能遵循相关法律法规规定或基金合同约定给基金财产造成损失的，对其行为依法承担\nC．基金管理公司应当制定估值及份额净值计价错误的识别及应急方案\nD．当估值或资产计价错误达到或超过基金资产净值的0.5%时，公募基金管理人应及时向中国证监会报告",
            "answer": "D",
            "explain": "1、基金管理公司应制定估值及份额净值计价错误的识别及应急方案。当估值或资产净值计价错误实际发生时，基金管理人应立即采取合理措施防止损失进一步扩大。当错误达到或超过基金资产净值的0.25%时，基金管理人应及时向中国证监会报告，故0.5%应是0.25%。"
        },
        {
            "title": "某企业的资产收益率是20%，若资产负债率也是20%，则净资产收益率（　　）。",
            "question": "A．15%\nB．25%\nC．20%\nD．30%",
            "answer": "B",
            "explain": "资产收益率=净利润/总资产=0.2，资产负债率=负债/总资产=0.2，权益乘数=1/(1-资产负债率)=1.25，净资产收益率=净利润/所有者权益=资产收益率*权益乘数=0.2*1.25=25%。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/jjjc-2.js